export function initMobileMenu() {
    const body = document.body;
    const hamburger = document.querySelector<HTMLElement>('.hamburger');
    const closeBtn = document.querySelector<HTMLElement>('.close-mobile-menu');

    if (!hamburger || !closeBtn) return;

    // Вычисляем ширину скроллбара один раз
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Открытие меню
    hamburger.addEventListener('click', () => {
        body.classList.add('menu-active');
        body.style.paddingRight = scrollbarWidth + 'px';
        body.style.overflow = 'hidden'; // чтобы скрыть скролл
    });

    // Закрытие меню
    closeBtn.addEventListener('click', () => {
        body.classList.remove('menu-active');
        body.style.paddingRight = '';
        body.style.overflow = '';
    });
}
